export default "__VITE_ASSET__DzknP$UH__"